export const SETTING_CAMPUS_COLUMN = 'SETTING_CAMPUS_COLUMN';
export const SETTING_CAMPUS_INDEX = 'SETTING_CAMPUS_INDEX';
export const SETTING_CAMPUS_LOADING_INDEX = 'SETTING_CAMPUS_LOADING_INDEX';
export const SETTING_CAMPUS_LOADING_SHOW = 'SETTING_CAMPUS_LOADING_SHOW';
export const SETTING_CAMPUS_OPTION = 'SETTING_CAMPUS_OPTION';
export const SETTING_CAMPUS_RESET = 'SETTING_CAMPUS_RESET';
export const SETTING_CAMPUS_SEARCH = 'SETTING_CAMPUS_SEARCH';
export const SETTING_CAMPUS_SHOW = 'SETTING_CAMPUS_SHOW';
